import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './editar-midia-digital.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import { AudioVideoImageDropzone } from '../../../../components/common/audioVideoImageDropzone/audio-video-image-dropzone';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
  Spinner,
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/midiaDigital';
import Swal from 'sweetalert2';
import CustomTextArea from '../../../../components/common/Textarea/textArea';

interface MidiaParams {
  dscMidia: string;
  seqUsuario: any;
  dscUriCdn: string | null;
  codMidia: number | null;
  dscDescricao: string | null;
  dscDireitoAutoral: string | null;
}

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const EditarMidiaDigital: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    arquivoMidia: { value: string; error: boolean };
    dscDireitoAutoral: { value: string; error: boolean };
    tipoMidiaId: { value: string; error: boolean };
    dscDescricao: { value: string; error: boolean };
  }>({
    titulo: { value: '', error: false },
    arquivoMidia: { value: '', error: false },
    dscDireitoAutoral: { value: '', error: false },
    tipoMidiaId: { value: '', error: false },
    dscDescricao: { value: '', error: false },
  });

  const [arquivo, setArquivo] = useState<any>();
  const [nomeArquivo, setNomeArquivo] = useState<any>();
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [tipoMidia, setTipoMidia] = useState<any[]>([]);
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [isLoadingEditButton, setLoadingEditButton] = useState<boolean>(false);
  const [isLoadingDeleteButton, setLoadingDeleteButton] = useState<boolean>(false);
  const [getNomeMidia, setGetNomeMidia] = useState<any>();
  const [nomeCdn, setNomeCdn] = useState<any>(null);
  const [nomeCdnFolderName, setNomeCdnFolderName] = useState<any>(null);

  const fetchObterMidiaDigital = async () => {
    setLoading(true);
    try {
      const midiaDigitalData = await api.obterMidia(Number(id));
      const { dscMidia, codMidia, dscDescricao, dscDireitoAutoral, dscUriCdn } = midiaDigitalData;

      setGetNomeMidia(midiaDigitalData.dscMidia);

      if (dscUriCdn) {
        const delimiter = "%2F";
        const index = dscUriCdn.lastIndexOf(delimiter);
        const finalFileName = index !== -1 ? dscUriCdn.substring(index + delimiter.length) : dscUriCdn;
        setNomeCdn(finalFileName);
      }   

      if (dscUriCdn) {
        const urlObj = new URL(dscUriCdn);
        const pathname = urlObj.pathname;
        const finalFileName = pathname.substring(pathname.lastIndexOf("/") + 1);
        setNomeCdnFolderName(finalFileName);
      }      

      setFormValues({
        titulo: { value: dscMidia, error: false },
        dscDescricao: { value: dscDescricao || '', error: false },
        dscDireitoAutoral: { value: dscDireitoAutoral || '', error: false },
        tipoMidiaId: { value: codMidia || '', error: false },
        arquivoMidia: { value: dscUriCdn || '', error: false },
      });
    } catch (error) {
      console.error("Erro ao buscar dados da mídia:", error);
    } finally {
      setLoading(false);
    }
  };

  const atualizarPreview = (url: string) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${new Date().getTime()}`;
  };
  
  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);

      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchtipoMidia = async () => {
      try {
        const data = await api.listarTipoDeMidia();
        setTipoMidia(data);
      } catch (error) {
        console.error('Erro ao buscar tipos de mídia:', error);
      }
    };

    fetchtipoMidia();
    fetchObterMidiaDigital();
  }, []);

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleMidiaSelecionada = async (selecionado: FileWithPath | null) => {
    if (selecionado) {
      const isImagem = selecionado.type.startsWith("image/");
      const isVideo = selecionado.type.startsWith("video/");
      const isAudio = selecionado.type.startsWith("audio/");
      const isPdf = selecionado.type === "application/pdf" || selecionado.name.toLowerCase().endsWith('.pdf');

      setNomeArquivo(selecionado.name);      
      setArquivo(selecionado);

      if (isImagem || isVideo || isAudio || isPdf) {
        setArquivoSelecionado(selecionado);
        setArquivo(selecionado);
      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const isFormValid = () => {
    const { titulo, tipoMidiaId, dscDescricao, dscDireitoAutoral, arquivoMidia } = formValues;
    const isArquivoSelecionado = arquivoSelecionado !== null || (arquivoMidia && arquivoMidia.value);
  
    const isValid =
      titulo.value &&
      tipoMidiaId.value &&
      dscDescricao.value &&
      isArquivoSelecionado;

    return isValid;
  };  

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingEditButton(true);
  
    const { tipoMidiaId } = formValues;
  
    const params: MidiaParams = {
      dscMidia: formValues.titulo.value,
      seqUsuario: seqUsuario,
      dscUriCdn: "",
      codMidia: Number(tipoMidiaId.value) || null,
      dscDescricao: formValues.dscDescricao.value || null,
      dscDireitoAutoral: formValues.dscDireitoAutoral.value || null
    };
  
    try {
      if (arquivoSelecionado) {
        const formData = new FormData();
        const nomeArquivo = nomeCdn;
        const nomePasta = 'bibliotecaDigital';

        formData.append('file', arquivo);
        formData.append('fileName', nomeArquivo);
        formData.append('folderName', nomePasta);
  
        const cdnData = await api.editarNoCdn(formData);
        let cdnUrl = "";
        
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }
        
        params.dscUriCdn = cdnUrl;
      } else {
        params.dscUriCdn = formValues.arquivoMidia.value;
      }
  
      await api.editarMidiaDigital(Number(id), params);
      setLoadingEditButton(false);
  
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Mídia editada com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/publicacao/gerenciar-biblioteca");
      });
    } catch (error) {
      setLoadingEditButton(false);
      console.error("Erro editar mídia:", error);
      Swal.fire({
        icon: "error",
        title: "Erro ao editar mídia!",
        text: "Houve um problema ao editar o arquivo. Tente novamente.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      });
    }
  };  

  const deletarMidia = async () => {
    Swal.fire({
      title: 'Tem certeza?',
      text: "Você realmente deseja deletar a mídia? Essa ação não poderá ser desfeita.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1789FC',
      cancelButtonColor: '#EDF2F7',
      confirmButtonText: 'Sim, deletar',
      cancelButtonText: 'Cancelar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingDeleteButton(true);
        try {
          await api.deletarNoCdn(nomeCdnFolderName);
          await api.deletarMidiaDigital(Number(id));
          setLoadingDeleteButton(false);
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Mídia deletada com sucesso.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate('/cms/publicacao/gerenciar-biblioteca');
          });
        } catch (error) {
          setLoadingDeleteButton(false);
          console.error('Erro ao deletar mídia:', error);
          Swal.fire({
            icon: 'error',
            title: 'Ocorreu um erro!',
            text: 'Erro ao deletar mídia. Tente novamente mais tarde.',
            confirmButtonColor: '#1789FC',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate('/cms/publicacao/gerenciar-biblioteca');
          });
        }
      }
    });
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height='100%'
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Mídia Digital
      </Heading>
      {loading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
      <Box mt="40px" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Tipo de Mídia</FormLabel>
                <Select
                  placeholder='Selecione um tipo de mídia'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.tipoMidiaId.value}
                  onChange={(e) => handleFieldChange('tipoMidiaId', e.target.value)}
                >
                  {tipoMidia.length > 0 ? (
                    tipoMidia.map(midia => (
                      <option key={midia.codMidia} value={midia.codMidia}>
                        {midia.dscMidia}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Nome da Mídia no CDN</FormLabel>
                <CustomInput 
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  placeholder="Digite um nome"
                  maxLength={60}
                />
              </FormControl>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6 mb-4">
            <FormControl isRequired className='mb-4'>
              <FormLabel mb="8px">Upload do arquivo digital</FormLabel>
              <AudioVideoImageDropzone
                onImageSelected={handleMidiaSelecionada}
                base64={atualizarPreview(formValues.arquivoMidia.value)}
                width={'100%'}
                height={300}
                defaultFileType={
                  formValues.tipoMidiaId.value === '3'
                    ? "audio"
                    : formValues.tipoMidiaId.value === '2'
                    ? "video"
                    : "image"
                }
              />
            </FormControl>

              <FormControl isRequired>
                <FormLabel mb="8px">Descrição da Mídia</FormLabel>
                <CustomTextArea
                  placeholder='Digite uma descrição'
                  value={formValues.dscDescricao.value}
                  onChange={(e) => handleFieldChange('dscDescricao', e.target.value)}
                  maxLength={100}
                  height={'20px'}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
            <FormControl isInvalid={formValues.dscDireitoAutoral.error}>
                <FormLabel mb="8px">Direito autoral</FormLabel>
                <CustomInput
                  value={formValues.dscDireitoAutoral.value}
                  onChange={(e: any) => handleFieldChange('dscDireitoAutoral', e.target.value)}
                  placeholder="Digite o direito autoral da mídia"
                  maxLength={200}
                />
              </FormControl>
            </div>
          </div>

          <Flex mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate('/cms/publicacao/gerenciar-biblioteca')}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isLoading={isLoadingEditButton}
              loadingText="Editando..."
              isDisabled={!isFormValid()}
            >
              Editar a Mídia
            </Button>
            <Button
              onClick={() => deletarMidia()}
              m="6px"
              colorScheme="red"
              variant="solid"
              _hover={{ bg: "red.600" }}
              isLoading={isLoadingDeleteButton}
              loadingText="Deletando..."
            >
              Deletar Mídia
            </Button>
          </Flex>
        </form>
      </Box>
      )}
    </Flex>
  );
};

export default EditarMidiaDigital;

